import * as index from './index';
index.HeatMap.Inject(index.Legend, index.Tooltip, index.Adaptor);
export * from './index';
